/**
 * Monthly warehouse document numbers: `PZ/NN/MM/RRRR`, `WZ/NN/MM/RRRR`.
 * Mirrors backend `buildMonthlyDocumentNumberOrderBy` (documentNumberRepository.js):
 * chronological order year → month → sequence; numbers outside the format
 * sort after all recognized ones (backend applies `NULLS LAST` regardless of
 * ASC/DESC direction), by plain string comparison.
 */
const MONTHLY_DOCUMENT_NUMBER = /^[A-Z]+\/(\d+)\/(\d{2})\/(\d{4})$/;

export function parseMonthlyDocumentNumber(value: string | null | undefined): number | null {
  const match = MONTHLY_DOCUMENT_NUMBER.exec((value || '').trim());
  if (!match) return null;
  const [, sequence, month, year] = match;
  return Number(year) * 1_000_000 + Number(month) * 10_000 + Number(sequence);
}

/**
 * Ascending comparator: older document first. Pass antd's `sortOrder` (the
 * sorter's third argument) through so legacy/non-format numbers still land
 * after all recognized ones once antd negates the result for `descend`.
 */
export function compareMonthlyDocumentNumbers(
  a: string | null | undefined,
  b: string | null | undefined,
  sortOrder?: 'ascend' | 'descend' | null,
): number {
  const keyA = parseMonthlyDocumentNumber(a);
  const keyB = parseMonthlyDocumentNumber(b);
  if (keyA !== null && keyB !== null) return keyA - keyB;
  const legacyLastSign = sortOrder === 'descend' ? -1 : 1;
  if (keyA !== null) return -1 * legacyLastSign;
  if (keyB !== null) return 1 * legacyLastSign;
  return (a || '').localeCompare(b || '');
}
